import { FC } from 'react';
import { Alert, Box, Divider, Text } from '@hopskipdrive/react-components';

import { FareBreakdownContainer } from './styles';

interface PerRiderFareOverviewProps {
  isFetching: boolean;
  perRiderFareDetails: PerRiderFareDetails;
  rideDetails?: RideDetails;
}

export const PerRiderFareOverview: FC<PerRiderFareOverviewProps> = ({ perRiderFareDetails, rideDetails }) => {
  const { creditsTotal, discountsTotal, fareSubtotal, fareTotal, riders, savingsTotal } = perRiderFareDetails;
  const savingsMessage =
    rideDetails && rideDetails.tripTemplate
      ? `Compared to the cost of ${riders.length} individual rides during the entire duration of the ride series.`
      : `Compared to the cost of ${riders.length} individual rides.`;

  return (
    <Box display="flex">
      <FareBreakdownContainer>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Text variant="labelXS" textColor="secondaryText">
            {(creditsTotal && creditsTotal !== '$0.00') || discountsTotal !== '$0.00' ? 'Fare subtotal' : 'Fare total'}
          </Text>
          <Text variant="labelL" textColor="secondary-hover">
            {creditsTotal !== '$0.00' || discountsTotal !== '$0.00' ? fareSubtotal : fareTotal}
          </Text>
        </Box>

        {discountsTotal !== '$0.00' && (
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Text variant="labelXS" textColor="secondaryText">
              Full-car discount
            </Text>
            <Text variant="labelL" textColor="success">
              -{discountsTotal}
            </Text>
          </Box>
        )}
        {creditsTotal && creditsTotal !== '$0.00' && (
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Text variant="labelXS" textColor="secondaryText">
              Credits
            </Text>
            <Text variant="labelL" textColor="success">
              -{creditsTotal}
            </Text>
          </Box>
        )}
        {fareSubtotal !== fareTotal && (
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Text variant="labelXS" textColor="secondaryText">
              Fare total
            </Text>
            <Box>
              <Divider sx={{ mt: '3px', mb: '3px' }} />
              <Text textColor="info-main" style={{ fontSize: '20px' }}>
                {fareTotal}
              </Text>
            </Box>
          </Box>
        )}
      </FareBreakdownContainer>
      {rideDetails && savingsTotal !== '$0.00' && (
        <Alert
          data-testid="savings-alert"
          aria-label="savings alert"
          variant="standard"
          severity={'success'}
          title={`This ride saved you ~${savingsTotal}`}
          message={savingsMessage}
          sx={{ ml: '12px', mt: '12px', width: '100%' }}
        />
      )}
    </Box>
  );
};
